import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a70d41e8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "p-4 max-w-lg mx-auto" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "text-2xl font-bold text-center mb-6" }, "JWT Decoder", -1))
const _hoisted_3 = { class: "mb-6" }
const _hoisted_4 = { class: "text-center mb-6" }
const _hoisted_5 = {
  key: 0,
  class: "bg-slate-900 border border-slate-700 shadow rounded p-4 text-slate-200"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "text-lg font-semibold mb-2" }, "Decoded JWT:", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "font-semibold" }, "Header:", -1))
const _hoisted_8 = { class: "p-2 bg-slate-800 rounded border border-slate-700 overflow-x-auto" }
const _hoisted_9 = { class: "mt-4" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "font-semibold" }, "Payload:", -1))
const _hoisted_11 = { class: "p-2 bg-slate-800 rounded border border-slate-700 overflow-x-auto" }
const _hoisted_12 = { class: "mt-4" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "font-semibold" }, "Signature:", -1))
const _hoisted_14 = { class: "p-2 bg-slate-800 rounded border border-slate-700 overflow-x-auto" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _withDirectives(_createElementVNode("textarea", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.jwtToken) = $event)),
        class: "w-full h-32 p-3 bg-slate-800 border border-slate-700 rounded-lg text-slate-200 focus:outline-none focus:ring-2 focus:ring-primary-500/50 shadow-sm",
        placeholder: "Enter JWT here"
      }, null, 512), [
        [_vModelText, _ctx.jwtToken]
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("button", {
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.decodeJWT && _ctx.decodeJWT(...args))),
        class: "bg-purple-500 hover:bg-purple-600 text-white font-bold py-2 px-4 rounded shadow"
      }, " Decode JWT ")
    ]),
    (_ctx.decodedToken)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("div", null, [
            _hoisted_7,
            _createElementVNode("pre", _hoisted_8, _toDisplayString(_ctx.decodedToken?.header), 1)
          ]),
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _createElementVNode("pre", _hoisted_11, _toDisplayString(_ctx.decodedToken?.payload), 1)
          ]),
          _createElementVNode("div", _hoisted_12, [
            _hoisted_13,
            _createElementVNode("pre", _hoisted_14, _toDisplayString(_ctx.jwtSignature), 1)
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}